import { MtDriveFile, QidDatapoint } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setQidDatapointList = (datapointList: readonly types.QidDatapointGroup[]) => ({
    type: inferLiteral(types.QID_DATAPOINT_LIST),
    datapointList,
})
export const setQidDatapointDelete = (datapoint: types.QidDatapointGroup) => ({
    type: inferLiteral(types.QID_DATAPOINT_DELETE),
    datapoint,
})


export const setQidDatapointExisting = (datapoints: QidDatapoint[]) => ({
    type: inferLiteral(types.QID_DATAPOINT_EXISTING),
    datapoints,
})
export const setQidDatapointNew = (datapoints: QidDatapoint[]) => ({
    type: inferLiteral(types.QID_DATAPOINT_NEW),
    datapoints,
})
export const setQidDatapointActiveCell = (cell: types.QidDatapointActiveCell) => ({
    type: inferLiteral(types.QID_DATAPOINT_ACTIVE_CELL),
    cell,
})
export const setQidDatapointChanges = (changes: types.QidDatapointChanges) => ({
    type: inferLiteral(types.QID_DATAPOINT_CHANGES),
    changes,
})
export const setQidDatapointDeleteExisting = (datapointIds: number[]) => ({
    type: inferLiteral(types.QID_DATAPOINT_DELETE_EXISTING),
    datapointIds,
})


export const setQidDatapointReferenceList = (referenceList: readonly MtDriveFile[]) => ({
    type: inferLiteral(types.QID_DATAPOINT_REFERENCE_LIST),
    referenceList,
})


export const setQidDatapointReloadList = (value: boolean) => ({
    type: inferLiteral(types.QID_DATAPOINT_RELOAD_LIST),
    value,
})
export const setQidDatapointReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.QID_DATAPOINT_RELOAD_EDIT),
    value,
})
